"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberRatingMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _Text = require("../../components/Text/Text.styles");
var _spaceMixin = require("../spaceMixin");
/** @class NumberRating */
/** @method */
var NumberRatingMixin = function NumberRatingMixin(props) {
  var fontType = props.fontType;
  return (0, _styledToken.default)({
    fontSize: "fontSizes." + fontType,
    lineHeight: "lineHeights." + fontType,
    iconFontSize: 'NumberRating.iconFontSize',
    color: 'NumberRating.color',
    textMarginRight: 'NumberRating.Text.marginRight'
  }, function (_ref) {
    var fontSize = _ref.fontSize,
      lineHeight = _ref.lineHeight,
      iconFontSize = _ref.iconFontSize,
      color = _ref.color,
      textMarginRight = _ref.textMarginRight;
    return (0, _styledComponents.css)(["font-size:", "px;line-height:", "px;", "{font-size:", "px;color:", ";margin-bottom:-2px;vertical-align:baseline;}", "{margin-right:", ";}"], fontSize, lineHeight, _Icon.StyledIcon, iconFontSize, color, _Text.StyledText, textMarginRight ? textMarginRight + "px" : (0, _spaceMixin.spaceMixin)(0.5)(props));
  })(props);
};
exports.NumberRatingMixin = NumberRatingMixin;